<template>
	<div class="row form-group">
	    <div class="col-xs-6"><label :for="'input'+content.contenttype"><strong v-if="!name || name == ''">{{content.contenttype}}</strong><strong v-else>{{ name }}</strong></label> </div>
		<div class="col-xs-6 text-right"> 
			<label class="switch">
                <input type="checkbox" :checked="content.contentvalue" @change="onSwitch()">
                <span class="slider round"></span>
            </label>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import api from '@/api'

export default{
	props:['value','name'],
	data: function(){
		return {
			content: this.value
		}
	},
	methods: {
		onSwitch: function(){
			let vm =this
			vm.content.contentvalue = !vm.content.contentvalue
			
			api.updateConfig(vm.content,function(error,response){
                if (error) {
                    console.error(error)
                    return
                }
            })
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/view/setting/input/InputBoolean.vue